var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2498 18.2517C11.639 18.2517 11.1433 17.756 11.1433 17.1452V6.33594C11.1433 5.72518 11.639 5.22949 12.2498 5.22949C12.8605 5.22949 13.3562 5.72518 13.3562 6.33594V17.1452C13.3562 17.756 12.8605 18.2517 12.2498 18.2517Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6589 12.8457H6.84082C6.22859 12.8457 5.73438 12.35 5.73438 11.7393C5.73438 11.1285 6.22859 10.6328 6.84082 10.6328H17.6589C18.2697 10.6328 18.7654 11.1285 18.7654 11.7393C18.7654 12.35 18.2697 12.8457 17.6589 12.8457Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/add-icon.7e455120aed4a9129a95bbf6be4f48e2.svg";
export { ForwardRef as ReactComponent };